import { use } from 'react';

import { useTranslation } from 'react-i18next';

import { Card, EmptyState } from '~components';
import { generalInformation } from '~constants';
import { UserRoleEnum } from '~enums';
import ScheduledActionsDataGrid from '~features/scheduledActions/components/dataGrids/scheduledActionsDataGrid';
import useAuthorize from '~hooks/useAuthorize';
import { extendDevice } from '~interfaces/device';

import DeviceActionsBar from '../components/deviceActionBar';
import DeviceContext from '../providers/deviceContext';

const DeviceScheduledActionsContainer = () => {
	const auth = useAuthorize();
	const { t } = useTranslation('entities');
	const isSuperAdmin = auth.authorize([UserRoleEnum.SuperAdmin]);
	const deviceContext = use(DeviceContext);
	const deviceId = deviceContext.device?.id ?? '0';
	const organisationId = deviceContext.overwrittenClientId;
	const showConnectivityProfileSettingButton =
		extendDevice(deviceContext.device)?.showConnectivityProfileSettingButton ?? false;

	return (
		<>
			<DeviceActionsBar
				deviceId={deviceId}
				organisationId={organisationId}
				showUnassignButton={
					isSuperAdmin &&
					organisationId != undefined &&
					organisationId != generalInformation.manufacturingOrganisationId
				}
				showAssignButton={
					isSuperAdmin && organisationId == generalInformation.manufacturingOrganisationId
				}
				showEditButton={isSuperAdmin}
				showChangeResourceGroupButton={
					isSuperAdmin && organisationId != generalInformation.manufacturingOrganisationId
				}
				showDeleteButton={isSuperAdmin}
				showConnectivityProfileSettingButton={showConnectivityProfileSettingButton}
				showRemoteActionsButton={isSuperAdmin}
			/>
			<Card title={t('schedule.labels.plural')} sx={{ height: '100%' }}>
				{deviceId != null || organisationId != null ?
					<ScheduledActionsDataGrid
						source={'device'}
						deviceId={deviceId}
						overwrittenClientId={organisationId}
					/>
				:	<EmptyState
						icon={'icon/bar-chart-square'}
						title={t('device.status.noScheduledActionsYetTitle')}
						description={t('device.status.noScheduledActionsYetDescription')}
					/>
				}
			</Card>
		</>
	);
};

export default DeviceScheduledActionsContainer;
